'use strict'

import * as React from 'react'
import Link from '@mui/material/Link'
import { useSelector } from 'react-redux'
import { viewId, titleName, table, analysisMode, kpiUnit, kpiOperator } from '../../_constants/Code'
import { getDynamoDB, getKpi as getKpiDB, registDynamoDB, updateDynamoDB } from '../../common/utils/DynamoDbUtils'
import { mainPageInfoList } from '../../_constants/PageInfoList'
import { PathInfoList } from '../../_constants/PathInfoList'

import { errorLog } from '../../common/logger/Logger'
import { formatDate } from '../../common/utils/DateUtils'
import { getObject, getCsvByJson } from '../../common/utils/FileUtils'

import Forbidden from '../../_components/Forbidden'

import '../../assets/css/vendor/normalize.css'
import '../../assets/css/vendor/animate.min.css'
import '../../assets/css/vendor/hamburgers.css'
import '../../assets/icon/style.css'
import '../../assets/css/style.css'
import '../../assets/js/tailwindcss.js'
import '../../assets/js/adobe_fonts.js'
import { useModal, useModalExtra } from '../../_components/Modal.js'

import _get from 'lodash/get'
import CertificationSelector from '../../common/utils/CertificationSelector.js'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import { useCertificationResources } from '../master/certificationInfo/extra/useCertificationInfo.js'
import _uniq from 'lodash/uniq'
import { pJson } from '../../common/utils/StringUtils.js'
import CustomTooltip from '../../_components/CustomTooltip.js'
import { produce } from 'immer'
import { ReactComponent as UndoIcon } from '../../assets/icon/undo.svg'

/** @import "./../../common/types" */

let kpi = []
let superKpi = []
let childKpi = []
let kpiYear = []
let initMode = null
const KpiContent = (props) => {
  const [kpiTgtInfo, setKpiTgtInfo] = React.useState([])
  const [stdKpiTgtInfo, setStdKpiTgtInfo] = React.useState([])
  const [consKpiTgtInfo, setConsKpiTgtInfo] = React.useState([])

  //サブKPI
  const [kpiTgtSubInfo, setKpiTgtSubInfo] = React.useState([])
  const [stdKpiTgtSubInfo, setStdKpiTgtSubInfo] = React.useState([])
  const [consKpiTgtSubInfo, setConsKpiTgtSubInfo] = React.useState([])

  /** @type {ReturnType<typeof React.useState<Record<string,string[]>>>} */
  const [kpiErrors, setKpiErrors] = React.useState({})
  const errorMessage = '入力内容に誤りがあります。'
  const errorMessageRef = React.useRef(null)
  const topOfPageRef = React.useRef(null)
  const showErrorMessage = React.useMemo(() => Object.keys(kpiErrors).length > 0, [kpiErrors])

  const [isLoaded, setIsLoaded] = React.useState(false)
  const [tgtMode, setTgtMode] = React.useState()

  const isParent = props.isParent
  const authority = props.authority
  const S2PageKey = 'S2'
  const page = mainPageInfoList.find((page) => {
    return page.key === S2PageKey
  })

  const [_childKpi, setChildKpi] = React.useState([])
  const [subKpi, setSubKpi] = React.useState([])
  const { getCertifications } = useCertificationResources()

  /**
   * @type {ReturnType<typeof React.useState<CertificationTree>>}
   */
  const [certifications, setCertifications] = React.useState({})
  const [certificationCodeMap, setCertificationCodeMap] = React.useState({})

  {
    /** kpi-target-setting.jsの処理を移行 開始 */
  }
  const get_fotmat_input_digit = (rawValue, fractionDigits) => {
    if (rawValue === '') {
      //ユーザーが空白にしたなら空白にして終了
      return ''
    }
    //入力値を数値だけ半角変換
    let halfWidthVal = rawValue.replace(/[０-９]/g, function (x) {
      return String.fromCharCode(x.charCodeAt(0) - 0xfee0)
    })
    //カンマを除去（入力値が数値か否かを確認のため）
    let commaRemovedVal = halfWidthVal.replaceAll(',', '').replaceAll('、', '')
    if (isNaN(commaRemovedVal)) {
      //数値でなければ空白にする
      return ''
    } else {
      //入力値をカンマ入り数字テキストに再変換
      return new Intl.NumberFormat('ja-JP', {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: 0, // 小数点以下がなければ表示しない
        roundingMode: 'trunc' // 切り捨て
      }).format(commaRemovedVal)
    }
  }

  // 入力時：テキスト入力フィールドのカンマ削除
  const focusKpiTgtValue = (e) => {
    // 入力値取得
    const val = e.target.value
    // 未入力ならば処理をしない
    if (val == '') {
      return
    }
    // カンマ除去
    let comma_removed_val = val.replaceAll(',', '')
    if (isNaN(comma_removed_val) || val.indexOf(',,') != -1) {
      //数値でなければ処理をしない
      return
    }
    e.target.value = comma_removed_val
  }

  // 入力完了時：テキスト入力フィールドのカンマ付加
  const blurKpiTgtValue = (cldKpi, year, e) => {
    // 未入力ならば処理をしない
    if (e.target.value == '') {
      return
    }
    let val = get_fotmat_input_digit(e.target.value, kpiUnit[cldKpi.Unit].numDecPlaces)
    let vKpiTgtInfo = kpiTgtInfo.map((v) => {
      if (v.Key == cldKpi.Key) {
        v.Value[year].Value = val
      }
      return v
    })
    setKpiTgtInfo(vKpiTgtInfo)
    e.target.value = val
  }

  const blurKpiTgtSubValue = (cldKpi, year, e) => {
    // 未入力ならば処理をしない
    if (e.target.value == '') {
      return
    }
    let val = get_fotmat_input_digit(e.target.value, kpiUnit[cldKpi.Unit].numDecPlaces)
    let vKpiTgtInfo = kpiTgtSubInfo.map((v) => {
      if (v.Key == cldKpi.Key) {
        v.Value[year].Value = val
      }
      return v
    })
    setKpiTgtSubInfo(vKpiTgtInfo)
    e.target.value = val
  }

  const scrollLeft = (e) => {
    const $parent = e.target.closest('.setting-table')
    const $tableWrapper = $parent.querySelector('.setting-table__scroll')
    $tableWrapper.scrollBy({
      left: -130,
      behavior: 'smooth'
    })
  }

  const scrollRight = (e) => {
    const $parent = e.target.closest('.setting-table')
    const $tableWrapper = $parent.querySelector('.setting-table__scroll')
    $tableWrapper.scrollBy({
      left: 130,
      behavior: 'smooth'
    })
  }
  const toggleVisibility = () => {
    document.querySelectorAll('.setting-table__scroll').forEach(function (element) {
      element.addEventListener('scroll', (event) => {
        // 要素の取得
        const $parent = event.target.closest('.setting-table')
        const $tableWrapper = $parent.querySelector('.setting-table__scroll')
        const $btnScrollLeft = $parent.querySelector('.setting-table__btn-scroll-left')
        const $btnScrollRight = $parent.querySelector('.setting-table__btn-scroll-right')
        const isScrollEnd = $tableWrapper.scrollWidth - ($tableWrapper.scrollLeft + $tableWrapper.clientWidth) < 1

        // ＜＞ボタンのdisabledの付け替え
        if ($tableWrapper.scrollLeft === 0) {
          // スクロール位置の左端
          if (!$btnScrollLeft.hasAttribute('disabled')) {
            $btnScrollLeft.setAttribute('disabled', '')
          }
        } else if ($tableWrapper.scrollLeft > 0 && !isScrollEnd) {
          // スクロール位置の中間
          if ($btnScrollLeft.hasAttribute('disabled')) {
            $btnScrollLeft.removeAttribute('disabled')
          }
          if ($btnScrollRight.hasAttribute('disabled')) {
            $btnScrollRight.removeAttribute('disabled')
          }
        } else if (isScrollEnd) {
          // スクロール位置の右端
          if (!$btnScrollRight.hasAttribute('disabled')) {
            $btnScrollRight.setAttribute('disabled', '')
          }
        }
      })
    })
  }
  {
    /** kpi-target-setting.jsの処理を移行 終了 */
  }

  const getKpiTgtInfo = async () => {
    try {
      let kpiTgtInfo = await getDynamoDB(table.KpiTargetInfo, null, props.corporationNumber)
      return kpiTgtInfo
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'getKpiTgtInfo', error)
    }
  }

  const getKpiTgtSubInfo = async () => {
    try {
      let kpiTgtSubInfo = await getDynamoDB(table.KpiTargetSubInfo, null, props.corporationNumber)
      return kpiTgtSubInfo
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'getKpiTgtInfo', error)
    }
  }

  const getTgtVal = (tgt) => {
    try {
      return (childKpi.length > 0 ? childKpi : childKpiRef.current).map((item) => {
        let value = {}
        let operator = kpiOperator.none
        let tgtInfo = tgt.find((v) => v.Key == item.Key)
        if (tgtInfo == undefined) {
          kpiYear.map((year) => {
            value[year] = {
              Value: ''
            }
          })
        } else {
          operator = tgtInfo.Operator
          kpiYear.map((year) => {
            value[year] = {
              Value: get_fotmat_input_digit(tgtInfo?.Value?.[year]?.Value || '', kpiUnit[item.Unit].numDecPlaces)
            }
          })
        }
        let rtnValue = {
          Key: item.Key,
          Operator: operator,
          Value: value
        }
        return rtnValue
      })
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'getTgtVal', error)
    }
  }

  const setKpiTgt = async () => {
    try {
      let kpiTgtInfo = await getKpiTgtInfo()
      let stdKpiTgtInfo = kpiTgtInfo.filter((v) => v.Mode == analysisMode.standalone)
      let consKpiTgtInfo = kpiTgtInfo.filter((v) => v.Mode == analysisMode.consolidated)
      stdKpiTgtInfo = getTgtVal(stdKpiTgtInfo.length > 0 ? stdKpiTgtInfo[0].TargetValue : [])
      consKpiTgtInfo = getTgtVal(consKpiTgtInfo.length > 0 ? consKpiTgtInfo[0].TargetValue : [])
      setKpiTgtInfo(initMode == analysisMode.standalone ? stdKpiTgtInfo : consKpiTgtInfo)
      setStdKpiTgtInfo(stdKpiTgtInfo)
      setConsKpiTgtInfo(consKpiTgtInfo)
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'setKpiTgt', error)
    }
  }

  const getTgtSubVal = (tgt) => {
    const tempKpi = convertTgtToKpi(tgt)

    try {
      return tempKpi.map((item) => {
        let value = {}
        let operator = kpiOperator.none
        let tgtInfo = tempKpi.find((v) => v.Key == item.Key)
        if (tgtInfo == undefined) {
          kpiYear.map((year) => {
            value[year] = {
              Value: ''
            }
          })
        } else {
          operator = tgtInfo.Operator
          kpiYear.map((year) => {
            value[year] = {
              Value: get_fotmat_input_digit(tgtInfo.Value?.[year].Value || '', kpiUnit[item.Unit].numDecPlaces)
            }
          })
        }
        let rtnValue = {
          ...item,
          Key: item.Key,
          Operator: operator,
          Value: value
        }
        return rtnValue
      })
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'getTgtVal', error)
    }
  }

  const setKpiTgtSub = async (mode = initMode) => {
    try {
      let kpiTgtSubInfo = await getKpiTgtSubInfo()
      const stdKpiTgtSubInfo = kpiTgtSubInfo.filter((v) => v.SuperKey.includes(analysisMode.standalone))
      const consKpiTgtSubInfo = kpiTgtSubInfo.filter((v) => v.SuperKey.includes(analysisMode.consolidated))

      //extract target value
      const stdTargetValue = getTgtSubVal(stdKpiTgtSubInfo)
      const consTargetValue = getTgtSubVal(consKpiTgtSubInfo)

      setKpiTgtSubInfo(mode === analysisMode.standalone ? stdTargetValue : consTargetValue)
      setStdKpiTgtSubInfo(stdTargetValue)
      setConsKpiTgtSubInfo(consTargetValue)

      const subKpi = convertTgtToKpi(mode === analysisMode.standalone ? stdKpiTgtSubInfo : consKpiTgtSubInfo)
      const sorted = await sortSubKpi(subKpi)

      setSubKpi(sorted)
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'setKpiTgt', error)
    }
  }

  const sortSubKpi = async (subKpi = []) => {
    /* INFO 資格マスタの表示順通りに3.4のサブKPIをソートする                             *
     * 現状はサブKPIが3.4のみしか存在しないためこの位置にソート処理を記載しているが、  *
     * ほかのサブKPIが追加された際には適切な場所に移動させる                         */

    // 資格マスター情報取得
    let fileData = await getObject(
      props.bucketName,
      PathInfoList.Folder.certificationFolder + PathInfoList.Objectkeyname.certification
    )
    fileData = new File([fileData], PathInfoList.Objectkeyname.certification, { type: 'text/csv' })
    const jsonData = await getCsvByJson(fileData) // blobからjsonに変換

    // 表示順を利用してソート
    const map = new Map(jsonData.map((e) => [e['資格コード'], Number(e['表示順'])]))
    return subKpi.sort((a, b) => map.get(a?.Code) - map.get(b?.Code))
  }

  function convertTgtToKpi(tgtInfo) {
    return tgtInfo
      .map((tgt) => {
        const { CreateDateTime = '', UpdateDateTime = '', SuperKey = '', TargetValue = [], Deleted = false } = tgt
        return TargetValue.map((e) => {
          const { Unit = '', Key = '', Operator = '', Value = [], Code = '' } = e

          return {
            Code,
            CreateDateTime,
            Unit,
            DeleteFlg: 0,
            Deleted,
            Operator,
            UpdateDateTime,
            Key,
            Value,
            SuperKey: SuperKey.split('#').pop().slice(0, 1)
          }
        })
      })
      .flat()
  }

  const changeTgt = (mode) => {
    try {
      let vKpiTgtInfo = kpiTgtInfo
      if (mode == analysisMode.standalone) {
        let vStdKpiTgtInfo = stdKpiTgtInfo
        setConsKpiTgtInfo(vKpiTgtInfo)
        setKpiTgtInfo(vStdKpiTgtInfo)
        setTgtMode(analysisMode.standalone)
      } else if (mode == analysisMode.consolidated) {
        let vConsKpiTgtInfo = consKpiTgtInfo
        setStdKpiTgtInfo(vKpiTgtInfo)
        setKpiTgtInfo(vConsKpiTgtInfo)
        setTgtMode(analysisMode.consolidated)
      }
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'changeTgt', error)
    }
  }

  const changeTgtSub = async (mode) => {
    try {
      let vKpiTgtInfo = kpiTgtSubInfo
      if (mode == analysisMode.standalone) {
        let vStdKpiTgtInfo = stdKpiTgtSubInfo
        setConsKpiTgtSubInfo(vKpiTgtInfo)
        setKpiTgtSubInfo(vStdKpiTgtInfo)
        setTgtMode(analysisMode.standalone)

        setSubKpi(await sortSubKpi(vStdKpiTgtInfo)) // こちらは形式合うのですが、ちょっと違います
      } else if (mode == analysisMode.consolidated) {
        let vConsKpiTgtInfo = consKpiTgtSubInfo
        setStdKpiTgtSubInfo(vKpiTgtInfo)
        setKpiTgtSubInfo(vConsKpiTgtInfo)
        setTgtMode(analysisMode.consolidated)

        setSubKpi(await sortSubKpi(vConsKpiTgtInfo))
      }
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'changeTgt', error)
    }
  }

  const changeOperetor = (cldKey, e) => {
    try {
      let vKpiTgtInfo = kpiTgtInfo.map((v) => {
        if (v.Key == cldKey) {
          v.Operator = e.target.value
        }
        return v
      })
      setKpiTgtInfo(vKpiTgtInfo)
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'changeOperetor', error)
    }
  }

  const changeOperetorSub = (cldKey, e) => {
    try {
      let vKpiTgtInfo = kpiTgtSubInfo.map((v) => {
        if (v.Key == cldKey) {
          v.Operator = e.target.value
        }
        return v
      })
      setKpiTgtSubInfo(vKpiTgtInfo)
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'changeOperetor', error)
    }
  }

  const changeKpiTgtValue = (cldKpi, year, e) => {
    let vKpiTgtInfo = kpiTgtInfo.map((v) => {
      if (v.Key == cldKpi.Key) {
        v.Value[year].Value = e.target.value
      }
      return v
    })
    setKpiTgtInfo(vKpiTgtInfo)
  }

  const changeKpiTgtSubValue = (cldKpi, year, e) => {
    let vKpiTgtInfo = kpiTgtSubInfo.map((v) => {
      if (v.Key == cldKpi.Key) {
        v.Value[year].Value = e.target.value
      }
      return v
    })
    setKpiTgtSubInfo(vKpiTgtInfo)
  }

  const removeComma = (kpiTgtInfo) => {
    return kpiTgtInfo.map((kpiTgt) => {
      for (let key in kpiTgt.Value) {
        kpiTgt.Value[key].Value = kpiTgt.Value[key].Value.replaceAll(',', '')
      }
      return kpiTgt
    })
  }

  const registKpi = async () => {
    try {
      let vdbKpiTgtInfo = await getKpiTgtInfo()
      let vdbStdKpiTgtInfo = vdbKpiTgtInfo.find((v) => v.Mode == analysisMode.standalone)
      let vdbConsKpiTgtInfo = vdbKpiTgtInfo.find((v) => v.Mode == analysisMode.consolidated)
      const nowDate = formatDate(new Date())

      let vKpiTgtInfo = removeComma(kpiTgtInfo)
      let vStdKpiTgtInfo = removeComma(stdKpiTgtInfo)
      // 単体
      if (vdbStdKpiTgtInfo == undefined) {
        // 登録
        const request = [
          {
            Mode: analysisMode.standalone,
            TargetValue: tgtMode == analysisMode.standalone ? vKpiTgtInfo : vStdKpiTgtInfo,
            CreateDateTime: nowDate,
            CreateUserId: props.userId,
            UpdateDateTime: nowDate,
            UpdateUserId: props.userId
          }
        ]
        registDynamoDB(table.KpiTargetInfo, 'CorporationNumber', props.corporationNumber, request, props.userId)
      } else {
        // 更新
        const pk = 'CorporationNumber'
        const key = {
          CorporationNumber: props.corporationNumber,
          Mode: analysisMode.standalone
        }
        const item = {
          TargetValue: tgtMode == analysisMode.standalone ? vKpiTgtInfo : vStdKpiTgtInfo,
          UpdateDateTime: nowDate,
          UpdateUserId: props.userId
        }
        updateDynamoDB(table.KpiTargetInfo, pk, props.corporationNumber, key, item, props.userId)
      }
      // 連結
      if (isParent) {
        let vConsKpiTgtInfo = removeComma(consKpiTgtInfo)
        if (vdbConsKpiTgtInfo == undefined) {
          // 登録
          const request = [
            {
              Mode: analysisMode.consolidated,
              TargetValue: tgtMode == analysisMode.consolidated ? vKpiTgtInfo : vConsKpiTgtInfo,
              CreateDateTime: nowDate,
              CreateUserId: props.userId,
              UpdateDateTime: nowDate,
              UpdateUserId: props.userId
            }
          ]
          registDynamoDB(table.KpiTargetInfo, 'CorporationNumber', props.corporationNumber, request, props.userId)
        } else {
          // 更新
          const pk = 'CorporationNumber'
          const key = {
            CorporationNumber: props.corporationNumber,
            Mode: analysisMode.consolidated
          }
          const item = {
            TargetValue: tgtMode == analysisMode.consolidated ? vKpiTgtInfo : vConsKpiTgtInfo,
            UpdateDateTime: nowDate,
            UpdateUserId: props.userId
          }
          updateDynamoDB(table.KpiTargetInfo, pk, props.corporationNumber, key, item, props.userId)
        }
      }
      const boxToastTimeoutSec = 4000
      addToastClassName()
      setTimeout(() => {
        removeToastClassName()
      }, boxToastTimeoutSec)
    } catch (error) {
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'registKpi', error)
    }
  }

  /**
   * KPITargetInfoの登録
   * @param {string} key
   * @param {Record<string,any>[]} targetValue
   * @returns
   */
  async function createRegisterKpi(key, targetValue) {
    const nowDate = formatDate(new Date())
    const request = [
      {
        SuperKey: key,
        TargetValue: targetValue,
        CreateDateTime: nowDate,
        UpdateDateTime: nowDate,
        CreateUserId: props.userId,
        UpdateUserId: props.userId
      }
    ]
    return registDynamoDB(table.KpiTargetSubInfo, 'CorporationNumber', props.corporationNumber, request, props.userId)
  }

  /**
   * KPITargetInfoの
   * @param {string} superKey
   * @param {Record<string,any>[]} targetValue
   * @returns
   */
  async function updateRegisterKpi(superKey, targetValue) {
    const nowDate = formatDate(new Date())
    // 更新
    const pk = 'CorporationNumber'
    const key = {
      CorporationNumber: props.corporationNumber,
      SuperKey: superKey
    }
    const item = {
      TargetValue: targetValue,
      UpdateDateTime: nowDate,
      UpdateUserId: props.userId
    }
    return updateDynamoDB(table.KpiTargetSubInfo, pk, props.corporationNumber, key, item, props.userId)
  }

  const scrollToNode = (ref) => {
    const top = ref?.getBoundingClientRect()?.top || 0
    const headerOffset = 150
    const offset = top + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    })
  }

  const checkIfExistsInKgiBeforeRegister = async (kpiTgtSubInfo) => {
    //削除の入力チェック
    const deletedKeys = kpiTgtSubInfo.filter((e) => e.Deleted).map((e) => e.Key)
    const isUsed = await checkIfUsedInKGI(deletedKeys)
    if (isUsed !== null && isUsed?.length > 0) {
      setKpiErrors((e) => {
        const temp = { ...e }

        isUsed.forEach((key) => {
          temp[key] = ['経営計画に設定されているため削除できません。']
        })
        return temp
      })

      scrollToNode(topOfPageRef.current)

      throw new Error('経営計画に存在します')
    } else {
      setKpiErrors({})
    }
  }

  const registSubKpi = async () => {
    try {
      const dbKpiTargetSubInfo = await getKpiTgtSubInfo()
      const subKeyParent = _uniq(subKpi.map((e) => e.Key.slice(0, 3)))

      const removeField = (e) => {
        const current = { ...e }
        delete current['Deleted']
        delete current['DeleteFlg']
        delete current['CreateDateTime']
        delete current['UpdateDateTime']
        delete current['SuperKey']

        return current
      }

      await checkIfExistsInKgiBeforeRegister(kpiTgtSubInfo)

      let requests = []

      for (let key of subKeyParent) {
        const stdParentKey = `${analysisMode.standalone}#${key}`
        const consParentKey = `${analysisMode.consolidated}#${key}`

        const dbStdKpiTargetInfo = dbKpiTargetSubInfo.find((e) => e.SuperKey === stdParentKey)
        const dbConsKpiTargetInfo = dbKpiTargetSubInfo.find((e) => e.SuperKey === consParentKey)

        const localKpiTgtSubInfo = produce(kpiTgtSubInfo, (draft) =>
          removeComma(draft.filter((e) => !e.Deleted).map(removeField))
        )
        const localStdKpiTgtSubInfo = produce(stdKpiTgtSubInfo, (draft) =>
          removeComma(draft.filter((e) => !e.Deleted).map(removeField))
        )

        const stdTgtValue = tgtMode == analysisMode.standalone ? localKpiTgtSubInfo : localStdKpiTgtSubInfo

        if (dbStdKpiTargetInfo === undefined) {
          requests.push(createRegisterKpi(stdParentKey, stdTgtValue))
        } else {
          requests.push(updateRegisterKpi(stdParentKey, stdTgtValue))
        }

        if (isParent) {
          const localConsKpiTgtSubInfo = produce(consKpiTgtSubInfo, (draft) => removeComma(draft.map(removeField)))
          const consTgtValue = tgtMode === analysisMode.consolidated ? localKpiTgtSubInfo : localConsKpiTgtSubInfo

          if (dbConsKpiTargetInfo === undefined) {
            requests.push(createRegisterKpi(consParentKey, consTgtValue))
          } else {
            requests.push(updateRegisterKpi(consParentKey, consTgtValue))
          }
        }
      }

      // 単体

      await Promise.all(requests)
      await setKpiTgtSub(tgtMode)
      const boxToastTimeoutSec = 4000
      addToastClassName()
      setTimeout(() => {
        removeToastClassName()
      }, boxToastTimeoutSec)
      return true
    } catch (error) {
      console.error(error)
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'registKpi', error)
      return false
    }
  }

  const getKpi = async () => {
    return getKpiDB(props.corporationNumber)
  }

  const childKpiRef = React.useRef([])

  const setKpi = async () => {
    const kpi = await getKpi()
    superKpi = kpi
      .filter((v) => v.SuperKey == '')
      .sort((a, b) => {
        a = Number(a.Key)
        b = Number(b.Key)
        return kpiSort(a, b)
      })

    const childKpi = kpi
      .filter((v) => v.SuperKey != '')
      .sort((a, b) => {
        a = Number(a.Key.split('.')[1])
        b = Number(b.Key.split('.')[1])
        return kpiSort(a, b)
      })
    setChildKpi(childKpi)
    childKpiRef.current = childKpi
    return childKpi
  }

  const setKpiYear = () => {
    let startYear =
      props.accPeriod != '12月' ? Number(props.kpiStartYear.slice(0, 4)) + 1 : Number(props.kpiStartYear.slice(0, 4))
    for (let i = 0; i < 10; i++) {
      let year = startYear + i + props.kpiStartYear.slice(-1)
      kpiYear.push(year)
    }
  }

  const kpiSort = (a, b) => {
    return a < b ? -1 : 1
  }

  const childKpi = _childKpi
    .filter((v) => v.SuperKey != '')
    .sort((a, b) => {
      a = Number(a.Key.split('.')[1])
      b = Number(b.Key.split('.')[1])
      return kpiSort(a, b)
    })

  const addToastClassName = () => {
    const buttonMenu = document.getElementById('box-toast')
    buttonMenu.classList.add('is-active')
  }

  const removeToastClassName = () => {
    const buttonMenu = document.getElementById('box-toast')
    buttonMenu.classList.remove('is-active')
  }

  const checkLinkStatus = (dashboardInfo) => {
    // ヘッダー部のモードと対象で選択されているモードが異なる場合はテキスト出力
    if (tgtMode != initMode) {
      return false
    }
    // リリース準備中のダッシュボードはテキスト出力
    if (tgtMode == analysisMode.standalone && !dashboardInfo.activeFlg) {
      return false
    }
    // 連結＆セグメントで表示しないダッシュボードはテキスト出力
    if (tgtMode == analysisMode.consolidated && !dashboardInfo.groupFlg) {
      return false
    }
    // それ以外はリンク
    return true
  }

  // 初期表示時、＜ボタンにdisabledをつける
  React.useEffect(() => {
    if (isLoaded) {
      const btnScrollLefts = document.querySelectorAll('.setting-table__btn-scroll-left')
      btnScrollLefts.forEach((v) => {
        v.setAttribute('disabled', '')
      })
    }
  }, [isLoaded])

  // スクロールイベント登録
  React.useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  // 初期表示の処理
  React.useEffect(() => {
    // タイトル設定
    document.title = props.pageTitle
    //window.scrollTo(0, 0);
    const fetchData = async () => {
      initMode = props.mode
      setTgtMode(initMode)

      await setKpi()
      setKpiYear()

      await Promise.all([setKpiTgt(), setKpiTgtSub()])

      const { certifications, certificationCodeMap } = await getCertifications()
      setCertifications(certifications)
      setCertificationCodeMap(certificationCodeMap)

      setIsLoaded(true)
    }
    fetchData()
  }, [])

  const handleModalClose = () => {
    props.modalExtra._closeUpModal()
  }

  /**
   * KPIの作成
   * @param {CertificationSelectorValue & {parent:string}} data
   * @param {CertificationTree} certifications
   * @returns
   */
  const generateKpi = (data) => {
    const [certificationId] = data.certificationCodeList
    const parent = data.parent
    const certificationCode = certifications[certificationId].CertificationCode

    const newKpi = {
      Code: certificationCode,
      CreateDateTime: null,
      DeleteFlg: 0,
      Deleted: false,
      Key: `${parent}.${certificationCode}`,
      Operator: kpiOperator.none,
      SuperKey: parent.slice(0, 1),
      Unit: 'people',
      UpdateDateTime: null
    }

    return newKpi
  }

  /**
   * KPITargetの作成
   * @param {CertificationSelectorValue & {parent:string}} data
   * @param {CertificationTree} certifications
   * @returns
   */
  const generateKpiTarget = (data) => {
    const [certificationId] = data.certificationCodeList
    const parent = data.parent
    let operator = kpiOperator.none
    const certificationCode = certifications[certificationId].CertificationCode

    let rtnValue = {
      Key: `${parent}.${certificationCode}`,
      Operator: operator,
      Code: certificationCode,
      Deleted: false,
      Unit: 'people',
      Value: Object.fromEntries(
        kpiYear.map((year) => [
          year,
          {
            Value: ''
          }
        ])
      )
    }
    return rtnValue
  }

  /**
   * KPT追加の処理
   * @param {CertificationSelectorValue} data
   */
  const handleCertificationSelect = (data) => {
    props.modalExtra._closeUpModal()
    const newKpi = generateKpi(data)
    const newKpiTargetValue = generateKpiTarget(data)

    setSubKpi((s) => [...s, newKpi])

    const predicate = (s) => [...s, newKpiTargetValue]
    setKpiTgtSubInfo(predicate)
  }

  React.useEffect(() => {
    function preventRedirect(e) {
      const check = confirm('登録されていないＫＰＩがあります、移動しますか？')
      if (!check) e.preventDefault()
    }

    if (_childKpi.length !== childKpiRef.current.length) {
      window.addEventListener('beforeunload', preventRedirect)
    } else {
      window.removeEventListener('beforeunload', preventRedirect)
    }

    return () => window.removeEventListener('beforeunload', preventRedirect)
  }, [_childKpi.length])

  /**
   * KPI追加のモダルを開く関数
   * @param {string} parent
   */
  const handleOpenAddKpi = (parent) => {
    const checkIfCertificationSetNameExists = (certificationId) =>
      kpiTgtSubInfo.some((e) => certifications?.[certificationId]?.CertificationCode === e.Code)

    props.showModal({
      title: `KPI追加`,
      description: 'KPI目標値を設定する資格を選択してください',
      body: (
        <CertificationSelector
          key={'open_certification' + Date.now()}
          certifications={certifications}
          singleMode
          onSave={(data) => handleCertificationSelect({ ...data, parent })}
          onClose={handleModalClose}
          checkIfCertificationSetNameExists={checkIfCertificationSetNameExists}
          corporationNumber={props.corporationNumber}
        />
      ),
      isCancel: false,
      isWide: false
    })
  }

  //削除の処理
  const onDelete = (childKpi) => {
    const id = childKpi.Key

    const predicate = (id) =>
      produce((state) => {
        state.forEach((e) => {
          if (e.Key === id) {
            e.Deleted = e.Deleted === undefined ? true : !e.Deleted
          }
        })
      })

    setSubKpi(predicate(id))
    setKpiTgtSubInfo(predicate(id))
    props.modalExtra._closeUpModal()
  }

  /**
   * 経営計画にあるかを確認
   * @param {string[]} key
   * @returns {Promise<string[]>}
   */
  async function checkIfUsedInKGI(key) {
    try {
      if (key.length === 0) return null

      // 経営計画
      const dynamoDBData = await getDynamoDB(table.BusinessPlan, null, props.corporationNumber, null, {
        Mode: analysisMode.standalone,
        Status: 'release',
        DeleteFlg: 0
      })

      if (!dynamoDBData) throw new Error('経営計画取得にエラー発生しました')

      let kpiList = new Set()

      const traverseKgiTree = (kgiTree) => {
        let kgiSet = new Set()
        for (let kgi of kgiTree) {
          kgi.Kpi_Key.forEach(kgiSet.add, kgiSet)

          if (kgi?.Sub_Kgi?.length > 0) {
            kgiSet = kgiSet.union(traverseKgiTree(kgi.Sub_Kgi))
          }
        }
        return kgiSet
      }

      for (let kgi of dynamoDBData) {
        const continuousMonitoring = _get(kgi, 'ContinuousMonitoringKpi', [])
        continuousMonitoring.forEach(kpiList.add, kpiList)

        const kgiTree = _get(kgi, 'KgiTree', [])

        kpiList = kpiList.union(traverseKgiTree(kgiTree))
      }
      const predicate = (e) => kpiList.has(e)

      if (key.some(predicate)) {
        return key.filter(predicate)
      }
      return null
    } catch (error) {
      console.error(error)
      errorLog('E000001', props.userId, viewId.kpiTargetSetting, 'checkIfUsedInKGI', error)
      return []
    }
  }

  //モダルの表示
  const handleDeleteKpi = async (childKpi) => {
    setKpiErrors({})

    onDelete(childKpi)
  }

  /**
   * 資格コードから名前を参照
   * @param {string} code
   */
  function getCertificationNameFromCode(code) {
    const certificationId = certificationCodeMap[code]
    if (!certificationId) return ''
    return certifications?.[certificationId]?.CertificationData?.Name || ''
  }

  const subKpiList = ['3.4']

  if (!isLoaded) {
    return null
  }
  return (
    <React.Fragment>
      <div id="box-toast" className="box-toast flex items-center pl-8 blue1 rounded-b-2xl fixed left-1/2 z-20">
        <div className="box-toast__text text-h6 white--text mr-1">目標設定を保存しました</div>
        <button
          type="button"
          className="box-toast__btn white--text p-5 leading-none"
          onClick={() => removeToastClassName()}
        >
          <span className="icon-close-s"></span>
        </button>
      </div>
      <main ref={topOfPageRef} className="page-container">
        <section className="page-content">
          <div className="centered-container">
            {/* コンテンツヘッダ */}
            <header className="page-header flex justify-center py-1">
              <h1 className="page-header__name text-h1 grey--text py-8">人的資本KPI目標設定</h1>
            </header>
            {/*  コンテンツボディ */}
            <div className="page-body">
              <div className="centered-container-1056">
                {/*  ===== リード ===== */}
                <p className="text-body text-center">S2 人的資本KPIに表示するKPIの目標値を入力してください。</p>
                {/*  ===== /リード ===== */}
                <div className="box-bordered mt-10 mb-16 pt-12 pb-16">
                  {/*  ===== ご注意事項 ===== */}
                  <div className="flex justify-center mb-10">
                    <ul className="text-list w-2/3 grey--text text--lighten-70 ml-auto mr-auto text-center">
                      <li className="-indent-4 ml-4">※ 現在の会計年度を含め、10年分の目標値を設定できます。</li>
                      <li className="-indent-4 ml-4">※ 目標値は半角数字で入力してください。</li>
                      <li className="-indent-4 ml-4">
                        ※ 目標値の設定がない場合は目標値=0としてKPIダッシュボードに表示されます。
                      </li>
                    </ul>
                  </div>

                  <div className={`red--text relative `} ref={errorMessageRef}>
                    <span className={`absolute left-[-70px] bottom-[100%]   ${showErrorMessage ? 'block' : 'hidden'}`}>
                      {errorMessage}
                    </span>
                  </div>

                  {/*  ===== /ご注意事項 ===== */}
                  {/*  ===== 対象 ===== */}
                  {/* 
                    ■単体/連携の選択ラジオのコンポーネントについて
                    単体・連携&セグメント分析を利用しない場合はdiv.box-xy-borderedにhiddenクラスを追加
                  */}
                  {/* ===== KPI設定 ===== */}
                  <div className="box-xy-bordered rounded-2xl mt-8 -mx-16 pt-10 pb-16 px-16">
                    {/* ===== 対象 ===== */}
                    <div className={`${isParent && authority.Company_AuthInfo.Availability ? '' : 'hidden'}`}>
                      <div className="flex justify-center items-center">
                        <div className="text-h6 mr-12">対象</div>
                        <ul className="flex gap-x-8">
                          <li>
                            <label className="ui-radio single">
                              <input
                                type="radio"
                                className="ui-radio__input"
                                name="target"
                                value="single"
                                defaultChecked={tgtMode == analysisMode.standalone}
                                onChange={() => {
                                  changeTgt(analysisMode.standalone)
                                  changeTgtSub(analysisMode.standalone)
                                }}
                              />
                              <span className="ui-radio__icon"></span>
                              <span className="ui-radio__ripple"></span>
                              <span className="ui-radio__label text-h7 font-Regular">単体</span>
                            </label>
                          </li>
                          <li>
                            <label className="ui-radio multiple">
                              <input
                                type="radio"
                                className="ui-radio__input"
                                name="target"
                                value="multiple"
                                defaultChecked={tgtMode == analysisMode.consolidated}
                                onChange={() => {
                                  changeTgt(analysisMode.consolidated)
                                  changeTgtSub(analysisMode.consolidated)
                                }}
                              />
                              <span className="ui-radio__icon"></span>
                              <span className="ui-radio__ripple"></span>
                              <span className="ui-radio__label text-h7 font-Regular">連結</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                      <p className="text-caption-2 mt-5 grey--text text--lighten-45 text-center">
                        「単体」を指定すると、画面の右上に表示されている会社が対象になります。
                      </p>
                      {/* ===== /対象 ===== */}
                      <hr
                        className={`${
                          !props.isParent
                            ? 'blue2 lighten-20'
                            : initMode == analysisMode.standalone
                            ? 'kpisetting single'
                            : 'kpisetting multiple'
                        } my-10`}
                      />
                    </div>

                    {superKpi
                      .filter((v) => v.DeleteFlg == 0)
                      .map((supKpi, supIdx) => {
                        return (
                          <div key={supIdx}>
                            <h3 className="text-h5 mt-10 mb-2 font-bold">
                              {supKpi.Key}. {supKpi.Name}
                            </h3>
                            <div className="setting-table relative is-kpi">
                              {/*  左にスクロールするボタン
                            非活性時はdisabled属性を追加
                          */}
                              <button
                                type="button"
                                className="setting-table__btn-scroll-left button w-8 h-8 flex items-center justify-center absolute"
                                onClick={(e) => scrollLeft(e)}
                              >
                                <span className="icon-arrow white--text rotate-180"></span>
                              </button>
                              {/*  右にスクロールするボタン
                            非活性時はdisabled属性を追加
                          */}
                              <button
                                type="button"
                                className="setting-table__btn-scroll-right button w-8 h-8 flex items-center justify-center absolute"
                                onClick={(e) => scrollRight(e)}
                              >
                                <span className="icon-arrow white--text"></span>
                              </button>
                              {/*  グラデーション1 */}
                              <div className="setting-table__gradation--left"></div>
                              {/*  グラデーション2 */}
                              <div className="setting-table__gradation--right"></div>
                              {/*  表組み */}
                              <div className="setting-table__scroll overflow-x-auto overflow-y-hidden">
                                <table className="setting-table__table w-full ">
                                  <thead>
                                    <tr>
                                      <th className="sticky top-0 left-0 z-10">設定単位</th>
                                      {kpiYear.map((item, idx) => {
                                        return (
                                          <th key={idx}>
                                            {item}
                                            {props.accPeriod}期
                                          </th>
                                        )
                                      })}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {childKpi
                                      .concat(subKpi)
                                      .filter((v) => v.SuperKey == supKpi.Key)
                                      .map((cldKpi, cldIdx) => {
                                        const keyDelimiter = '.'
                                        //KPIの値
                                        let kpiTgt = kpiTgtInfo
                                          .concat(kpiTgtSubInfo || [])
                                          ?.find((v) => v.Key == cldKpi.Key)
                                        let mIdx = cldKpi.Key.split('.')[0] - 1
                                        let sIdx = cldKpi.Key.split('.')[1] - 1
                                        let dashboardInfo = page.dashboardList[mIdx].dashboard[sIdx]
                                        //リンクの確認
                                        let linkFlg = checkLinkStatus(dashboardInfo)
                                        //非活性フラッグ
                                        let disabledFlg = !dashboardInfo.activeFlg
                                        //単位
                                        let unit = kpiUnit[cldKpi.Unit].name
                                        let availability = false
                                        let authInfo = authority.Dashboard_AuthInfo

                                        const isSubKpi = cldKpi.Key.split(keyDelimiter).length > 2
                                        const isKpiDeleted = cldKpi.Deleted

                                        if (authInfo?.Availability) {
                                          // ダッシュボードへの参照権限がある
                                          let dashboardAuthConf = authInfo.Auth_Conf.find(
                                            (auth) => auth.Key === S2PageKey
                                          )
                                          if (dashboardAuthConf?.Availability) {
                                            // 大見出しレベルで参照権限がある
                                            let dashboardList = dashboardAuthConf.DashboardList.find(
                                              (d) => d.Key === S2PageKey + '.' + String(mIdx + 1)
                                            )
                                            if (dashboardList?.Availability) {
                                              // 中見出しレベルで参照権限がある

                                              let key = cldKpi.Key
                                              if (isSubKpi) key = key.slice(0, 3)

                                              let authDashboard = dashboardList.Dashboard.find(
                                                (d) => d === S2PageKey + '.' + key
                                              )
                                              if (authDashboard) {
                                                // 小見出しレベルで参照権限がある
                                                availability = true
                                              }
                                            }
                                          }
                                        }

                                        return (
                                          <tr key={cldIdx}>
                                            <th
                                              className={
                                                `sticky left-0 z-10 setting-table__col-name` +
                                                ` ${isKpiDeleted && '!bg-[#cfcfcf]'}`
                                              }
                                              title={window.debug_ && pJson(cldKpi)}
                                            >
                                              <div
                                                className={`flex items-center setting-heading  ${
                                                  isSubKpi && 'w-full'
                                                } `}
                                              >
                                                {(() => {
                                                  if (linkFlg && availability && !isSubKpi) {
                                                    return (
                                                      <div className="setting-heading__name">
                                                        <Link
                                                          underline="none"
                                                          href={page.url + mIdx + '/' + sIdx}
                                                          target="_blank"
                                                        >
                                                          {cldKpi.Key} {cldKpi.Name}
                                                        </Link>
                                                      </div>
                                                    )
                                                  }

                                                  if (isSubKpi) {
                                                    let isDisabled = disabledFlg

                                                    const isLink =
                                                      cldKpi.CreateDateTime !== null &&
                                                      availability &&
                                                      !isKpiDeleted &&
                                                      props.mode !== analysisMode.consolidated

                                                    const link = page.url + mIdx + '/' + sIdx + `?kpiCode=${cldKpi.Key}`
                                                    const deletedStyle = '!line-through disabled !text-gray-900'

                                                    const linkProps = {
                                                      className: `h-5 truncate ` + `  ${isKpiDeleted && deletedStyle} `,
                                                      underline: 'none',
                                                      href: !isKpiDeleted ? link : '',
                                                      target: '_blank'
                                                    }

                                                    const name = getCertificationNameFromCode(cldKpi.Code)

                                                    return (
                                                      <CustomTooltip title={name}>
                                                        {(ref) => {
                                                          return (
                                                            <div
                                                              id={`kpiId_${cldKpi.Key}`}
                                                              role="button"
                                                              className={
                                                                `setting-heading__name flex-1 ` +
                                                                ` ml-4 !mr-0 flex items-center justify-between max-w-[155px]`
                                                              }
                                                            >
                                                              {isLink && (
                                                                <Link {...linkProps} ref={ref}>
                                                                  {name}
                                                                </Link>
                                                              )}

                                                              {!isLink && (
                                                                <div
                                                                  className={
                                                                    `setting-heading__name !truncate ` +
                                                                    `${
                                                                      disabledFlg || !availability ? 'is-disabled' : ''
                                                                    } ` +
                                                                    `${isKpiDeleted && deletedStyle} `
                                                                  }
                                                                  ref={ref}
                                                                >
                                                                  {name}
                                                                </div>
                                                              )}

                                                              {/* 　- ①-1「対象」で連結を選択している　- 単体モードで人的資本KPI画面で該当(親)の小見出しが非活性で表示される */}

                                                              {!isDisabled && (
                                                                <IconButton
                                                                  size="small"
                                                                  onClick={() => handleDeleteKpi(cldKpi)}
                                                                >
                                                                  {isKpiDeleted && (
                                                                    <UndoIcon className="z-20 w-[20px] h-[20px]" />
                                                                  )}
                                                                  {!isKpiDeleted && <DeleteIcon fontSize="small" />}
                                                                </IconButton>
                                                              )}
                                                            </div>
                                                          )
                                                        }}
                                                      </CustomTooltip>
                                                    )
                                                  }

                                                  return (
                                                    <div
                                                      className={`setting-heading__name ${
                                                        disabledFlg || !availability ? 'is-disabled' : ''
                                                      }`}
                                                    >
                                                      {cldKpi.Key} {cldKpi.Name}
                                                    </div>
                                                  )
                                                })()}
                                                {(() => {
                                                  if (cldKpi.HasSubKpi || subKpiList.includes(cldKpi.Key)) {
                                                    let isDisabled = tgtMode === analysisMode.consolidated
                                                    isDisabled |= disabledFlg

                                                    return (
                                                      <>
                                                        <span className="flex-1"></span>
                                                        <button
                                                          disabled={isDisabled}
                                                          className={
                                                            `mr-1 px-2 rounded bg-blue-700 text-xs gap-1 font-normal focus:ring-2 focus:ring-blue-600 min-w-[50px]` +
                                                            ` text-white inline-flex justify-center items-center ${
                                                              isDisabled && 'bg-gray-700/50'
                                                            }`
                                                          }
                                                          onClick={() => handleOpenAddKpi(cldKpi.Key)}
                                                        >
                                                          <i className="icon-plus-line text-lg"></i>
                                                          <span>追加</span>
                                                        </button>
                                                      </>
                                                    )
                                                  }

                                                  let isDisabled = tgtMode === analysisMode.consolidated && isSubKpi
                                                  isDisabled |= disabledFlg
                                                  isDisabled |= isKpiDeleted

                                                  return (
                                                    <>
                                                      <div className="setting-heading__unit">
                                                        {!disabledFlg ? unit : unit == '' ? unit : '-'}
                                                      </div>
                                                      <div className="setting-heading__select">
                                                        <div className="select-control">
                                                          <select
                                                            name="select_3_1"
                                                            className="select-control__select rounded-full text-extra-small"
                                                            value={kpiTgt?.Operator || ''}
                                                            onChange={(e) => {
                                                              changeOperetorSub(cldKpi.Key, e)
                                                              changeOperetor(cldKpi.Key, e)
                                                            }}
                                                            disabled={isDisabled}
                                                          >
                                                            <option value={kpiOperator.none}>{kpiOperator.none}</option>
                                                            <option value={kpiOperator.more}>{kpiOperator.more}</option>
                                                            <option value={kpiOperator.less}>{kpiOperator.less}</option>
                                                          </select>
                                                          <div className="select-control__icon flex text-base items-center justify-center w-8 absolute pointer-events-none inset-y-0 right-0">
                                                            <span
                                                              className={`icon-arrow rotate-90 ${
                                                                !disabledFlg ? '' : 'is-disabled'
                                                              }`}
                                                            ></span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )
                                                })()}
                                              </div>
                                              {kpiErrors?.[cldKpi.Key]?.map((e) => (
                                                <div
                                                  key={`errors${cldKpi.Key}`}
                                                  id={`kpiId_${cldKpi.Key}`}
                                                  className="ml-4 my-2 text-red-500  text-left !font-normal !text-[13px]"
                                                >
                                                  {e}
                                                </div>
                                              ))}
                                            </th>
                                            {kpiYear.map((year, yearIdx) => {
                                              if (subKpiList.includes(cldKpi.Key)) {
                                                return <td key={yearIdx}></td>
                                              }
                                              return (
                                                <td key={yearIdx} className={` ${isKpiDeleted && '!bg-gray-500/50'}`}>
                                                  <input
                                                    className="text-input format-digit"
                                                    type="text"
                                                    name={'text_' + yearIdx}
                                                    placeholder={!disabledFlg ? '数値を入力' : ''}
                                                    value={kpiTgt?.Value[year].Value}
                                                    onChange={(e) => {
                                                      if (isSubKpi) changeKpiTgtSubValue(cldKpi, year, e)
                                                      else changeKpiTgtValue(cldKpi, year, e)
                                                    }}
                                                    onFocus={(e) => focusKpiTgtValue(e)}
                                                    onBlur={(e) => {
                                                      if (isSubKpi) blurKpiTgtSubValue(cldKpi, year, e)
                                                      else blurKpiTgtValue(cldKpi, year, e)
                                                    }}
                                                    disabled={disabledFlg || isKpiDeleted}
                                                  />
                                                </td>
                                              )
                                            })}
                                          </tr>
                                        )
                                      })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )
                      })}

                    <hr
                      className={`${
                        !props.isParent
                          ? 'blue2 lighten-20'
                          : initMode == analysisMode.standalone
                          ? 'kpisetting single'
                          : 'kpisetting multiple'
                      } mt-16 mb-8`}
                    />

                    {/*  登録ボタン */}
                    <div className="text-center">
                      <button
                        className="btn btn-register-kpi-target white--text grey rounded-lg px-16 text-h5 font-medium"
                        disabled={!authority.Kpi_AuthInfo.Auth_Conf.Regist}
                        onClick={() => {
                          try {
                            setKpiErrors({})

                            registSubKpi().then((success) => {
                              if (success) registKpi()
                            })
                          } catch (e) {
                            setKpiErrors({ serverError: [errorMessage] })
                            scrollToNode(topOfPageRef.current)
                          }
                        }}
                      >
                        登録
                      </button>
                    </div>
                  </div>
                  {/*  ===== /KPI設定 ===== */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  )
}

const KpiSetting = () => {
  const state = useSelector((state) => state)

  if (state.authority.Kpi_AuthInfo.Availability && state.authority.Kpi_AuthInfo.Auth_Conf.View) {
    return (
      <KpiContent
        userId={state.user.sub}
        pageTitle={titleName.kpiSetting + titleName.common}
        corporationNumber={state.company.corporationNumber}
        bucketName={'chrofy-' + process.env.REACT_APP_ENV + '-' + state.company.corporationNumber}
        accPeriod={state.company.accPeriod}
        kpiStartYear={state.company.kpiStartYear}
        isParent={state.company.isParent}
        mode={state.analysis.mode}
        authority={state.authority}
        showModal={useModal()}
        modalExtra={useModalExtra()}
      />
    )
  } else {
    return <Forbidden />
  }
}

export default KpiSetting
